import Mensalidades from './pages/tesouraria/Mensalidades';
import LivroCaixa from './pages/tesouraria/LivroCaixa';
import TesourariaDashboard from './pages/tesouraria/TesourariaDashboard';
// import Mensalidades from './pages/tesouraria/Mensalidades'; (quando criarmos este)
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ThemeProvider } from './context/ThemeContext';
import { Toaster } from './components/ui/sonner';
import Navbar from './components/Navbar';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import Purchases from './pages/Purchases';
import Customers from './pages/Customers';
import StockAdjustments from './pages/StockAdjustments';
import Sales from './pages/Sales';
import Dinners from './pages/Dinners';
import Reports from './pages/Reports';
import AccountsReceivable from './pages/AccountsReceivable';
import Settings from './pages/Settings';
import Churrasqueiros from './pages/Churrasqueiros';
import EventMenu from './pages/EventMenu';
import MenuBoard from './pages/MenuBoard';
import Suppliers from './pages/Suppliers';
import '@/App.css';

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-background">
        <p className="text-muted-foreground font-mono">Carregando...</p>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'visualizador') return <Navigate to="/reports" replace />;
    if (user.role === 'vendedor') return <Navigate to="/dashboard" replace />;
    return <Navigate to="/dashboard" replace />;
  }
  
  return (
    <div className="min-h-screen w-full flex flex-col bg-background overflow-x-hidden">
      <Navbar />
      <main className="flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
    </div>
  );
};

function AppRoutes() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <p className="text-muted-foreground font-mono">Carregando...</p>
      </div>
    );
  }

  // Determine default redirect based on role
  const getDefaultRedirect = () => {
    if (user?.role === 'visualizador') return "/reports";
    return "/dashboard";
  }

  return (
    <Routes>
      <Route 
        path="/login" 
        element={user ? <Navigate to={getDefaultRedirect()} replace /> : <Login />} 
      />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Dashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/products" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Products />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/stock-adjustments" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <StockAdjustments />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/suppliers" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Suppliers />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/purchases" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Purchases />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/customers" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Customers />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sales" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor', 'visualizador']}>
            <Sales />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/dinners" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <Dinners />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/churrasqueiros" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Churrasqueiros />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/reports" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor', 'visualizador']}>
            <Reports />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/accounts-receivable" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <AccountsReceivable />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/settings" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Settings />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/event-menu" 
        element={
          <ProtectedRoute allowedRoles={['admin', 'vendedor']}>
            <EventMenu />
          </ProtectedRoute>
        } 
      /> 
      <Route 
        path="/menu-board" 
        element={<MenuBoard />} 
      />
      
      {/* --- INÍCIO ROTAS DA TESOURARIA PROTEGIDAS --- */}
      <Route 
        path="/tesouraria/dashboard" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <TesourariaDashboard />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/tesouraria/caixa" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <LivroCaixa />
          </ProtectedRoute>
        } 
      />
      
      <Route 
        path="/tesouraria/mensalidades" 
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <Mensalidades />
          </ProtectedRoute>
        } 
      />
      {/* --- FIM ROTAS DA TESOURARIA PROTEGIDAS --- */}

      <Route path="/" element={<Navigate to={getDefaultRedirect()} replace />} />
      
    </Routes>
  );
}   

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <BrowserRouter>
          <div className="App bg-noise">
            <AppRoutes />
            <Toaster 
              theme="dark" 
              position="top-right"
              toastOptions={{
                style: {
                  background: '#18181b',
                  color: '#fafafa',
                  border: '1px solid #27272a',
                },
              }}
            />
          </div>
        </BrowserRouter>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
